var _style, _path, _path2, _path3, _path4, _path5, _ellipse, _ellipse2, _path6, _path7, _path8, _path9, _circle, _ellipse3, _path10, _path11, _path12, _path13, _ellipse4, _ellipse5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLesson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "Capa_1",
    x: 0,
    y: 0,
    style: {
      enableBackground: "new 0 0 500 500"
    },
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#e84134}.st7{fill:#fddbbb}.st8{fill:#f2f2f2}.st9{fill:#3b3b3b}.st10{fill:#808181}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M472 248.778c0 123.145-99.83 222.974-222.968 222.974-123.148 0-222.98-99.829-222.98-222.974s99.832-222.97 222.98-222.97C372.169 25.807 472 125.632 472 248.777z",
    className: "st0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M256.875 268.902v-99.84c0-18.666 15.184-33.85 33.85-33.85h94.926c18.666 0 33.851 15.184 33.851 33.85v99.84H256.875z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.019 202.057h12.473v55.962h-12.473z",
    style: {
      fill: "#fcbe06"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.956 185.911h12.479v72.108h-12.479z",
    style: {
      fill: "#ee7025"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M343.913 213.14h12.479v44.88h-12.479z",
    className: "st0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M367.85 167.114h12.485v90.905H367.85z",
    style: {
      fill: "#a0b61d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.797 157.539h35.427v6.715h-35.427z",
    style: {
      fill: "#9a9999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m289.065 277.444 31.044-57.474-35.918 52.692z",
    style: {
      fill: "#0c0b0b"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M289.203 282.658s8.042-10.237-.633-14.533c-8.675-4.295-9.742 8.767-9.742 8.767l10.375 5.766z",
    className: "st7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m277.104 278.432 1.247-2.785 11.679 6.907-1.589 2.532z",
    className: "st8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M205.456 307.252s47.647 40.824 84.173-22.544l-12.633-8.228s-23.6 48.571-59.625 22.187l-11.915 8.585z",
    className: "st9"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 282.813,
    cy: 289.629,
    className: "st10",
    rx: 1.381,
    ry: 1.38,
    transform: "rotate(-66.69 282.831 289.626)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 285.402,
    cy: 285.711,
    className: "st10",
    rx: 1.38,
    ry: 1.379,
    transform: "rotate(-66.673 285.393 285.699)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M118.19 292.77s-2.084-96.271 58.715-98.162c77.505-2.41 52.584 108.47 52.584 108.47l-111.3-10.307z",
    className: "st7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M165.672 241.877s.06.537.138 1.477c.065.454.143.983.242 1.596.127.615.27 1.302.488 2.026.215.725.514 1.478.87 2.239.4.732.835 1.497 1.427 2.143a7.641 7.641 0 0 0 2.035 1.641 5.621 5.621 0 0 0 2.493.683c1.747.095 3.459-.75 4.713-1.965.643-.599 1.146-1.324 1.605-2.023.414-.732.78-1.455 1.051-2.163.126-.357.26-.695.367-1.027l.28-.955c.152-.608.27-1.148.37-1.593.148-.9.248-1.423.248-1.423l.007-.037a.548.548 0 0 1 1.085.08s.023.549.037 1.521c-.025.485-.041 1.079-.12 1.758l-.158 1.082c-.06.382-.177.775-.272 1.192a14.445 14.445 0 0 1-.968 2.619c-.482.88-1.011 1.83-1.813 2.643-.779.821-1.722 1.587-2.847 2.11a8.169 8.169 0 0 1-3.68.768c-1.284-.041-2.542-.43-3.62-1.035-1.09-.6-1.973-1.443-2.683-2.327-.734-.878-1.198-1.863-1.598-2.785a14.003 14.003 0 0 1-.755-2.691c-.06-.423-.146-.825-.175-1.21l-.07-1.093c-.021-.688.004-1.3.022-1.783.092-.938.16-1.475.16-1.475a.565.565 0 0 1 1.12.007zM207.476 243.51s.06.537.139 1.476c.064.455.142.984.241 1.597.127.614.27 1.302.488 2.026.215.725.514 1.477.87 2.238.4.732.835 1.498 1.427 2.144a7.639 7.639 0 0 0 2.035 1.64 5.62 5.62 0 0 0 2.493.684c1.747.095 3.459-.751 4.713-1.965.643-.6 1.146-1.324 1.605-2.023.414-.732.78-1.456 1.051-2.163.126-.357.26-.695.367-1.028l.281-.954c.151-.608.27-1.148.37-1.594.148-.9.247-1.422.247-1.422l.007-.037a.548.548 0 0 1 1.085.08s.023.548.037 1.521c-.024.484-.041 1.079-.12 1.757l-.158 1.083c-.06.382-.177.775-.271 1.191a14.457 14.457 0 0 1-.969 2.62c-.482.88-1.01 1.829-1.813 2.643-.778.82-1.722 1.587-2.847 2.109a8.168 8.168 0 0 1-3.68.768c-1.284-.04-2.542-.429-3.62-1.034-1.09-.6-1.973-1.444-2.683-2.327-.734-.879-1.198-1.863-1.598-2.785a13.993 13.993 0 0 1-.755-2.692c-.06-.423-.145-.824-.175-1.21l-.07-1.092c-.021-.689.004-1.3.022-1.783.092-.939.16-1.475.16-1.475a.565.565 0 0 1 1.12.007zM230.635 379.38s.317-42.464.857-84.291l-14.614-.298-32.936 43.203-29.46-45.229-38.211-.93c6.902 41.621 15.754 87.551 15.754 87.551",
    className: "st9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m219.833 294.791-35.456 44.485-33.703-46.661z",
    className: "st8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m219.833 294.791-.214 19.548-11.106 1.866 1.032 14.92-25.168 8.151zM184.377 339.276l-23.655-12.529 1.227-10.781-11.459-4.606.184-18.745z",
    className: "st10"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m195.466 303.548-3.453-5.571-9.378-.653-3.68 6.439 3.624 4.559-5.818 20.457 7.616 10.497 9.425-11.814-2.903-18.643z",
    style: {
      fill: "#b45830"
    }
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 183.553,
    cy: 345.178,
    r: 3.168,
    className: "st10",
    transform: "rotate(-7.297 183.475 345.068)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 184.248,
    cy: 359.042,
    className: "st10",
    rx: 3.167,
    ry: 3.168,
    transform: "rotate(-7.279 184.23 359.014)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M253.522 171.685s6.042 73.782-101.106 47.948l-5.913 20.514s-8.57-11.992-12.134-1.263c-4.102 12.353 8.434 9.941 8.434 9.941s-13.375 24.995-25.733 34.797c-.69.547-22.714-114.598 21.995-100.115 0 0 5.006-22.696 39.937-22.61 45.456.11 43.026 39.997 74.52 10.788z",
    className: "st9"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M212.173 268.687c.576.072.98.593.931 1.171-.794 9.39-8.794 16.639-18.334 16.382-9.54-.257-17.135-7.925-17.425-17.343a1.08 1.08 0 0 1 .997-1.119c11.465-.767 22.743-.466 33.831.91z",
    style: {
      fill: "#ec7d87"
    }
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M57.68 280.933s-8.92-9.482-.662-14.532c8.258-5.05 10.483 7.866 10.483 7.866l-9.82 6.666z",
    className: "st7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m69.273 275.803-1.574-2.56-10.799 7.92 1.901 2.352z",
    className: "st8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M140.763 316.549s-51.59 15.574-83.49-33.11l11.85-9.319s23.234 39.24 67.918 27.647l3.722 14.782z",
    className: "st9"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.499,
    cy: 287.735,
    className: "st10",
    rx: 1.38,
    ry: 1.381,
    transform: "rotate(-28.41 64.494 287.718)"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.573,
    cy: 284.062,
    className: "st10",
    rx: 1.379,
    ry: 1.38,
    transform: "rotate(-28.43 61.566 284.038)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLesson);
export default __webpack_public_path__ + "static/media/lesson.7908460c12c7856db76bf4be889e0e98.svg";
export { ForwardRef as ReactComponent };